<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/B1mhI/tc-custom/9781534326361.jpg?1729186463979" alt="This image is the cover for the book Ice Cream Man Vol 8: Subjects & Objects, Ice Cream Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ice Cream Man Vol 8: Subjects & Objects, Ice Cream Man
      </h1>
      <p class="bookDescription body article font2">
        <p>Open wide for four more scoops of the bestselling critically acclaimed psycho-horror comic ICE CREAM MAN.  Here bound with medium-grade paper glue are four tales of objective subjectivity: a man's last wishes are carried out; a controlled experiment loses all control; a cosmic scale is balanced (in verse!); Doug tries his darndest to get clean.  It's another assemblage of anguish and ennui for the anthologically-inclined art appreciator.  Lickety split y'all!   Collects ICE CREAM MAN #29-32</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. Maxwell Prince, Martín Morazzo, Chris O'Halloran
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?874c444a